import { Key } from './key';

export class KeysetItem {
    id: number;
    name: string;
    key: Key;
}
